export const EVENTS = ({
  COMMENT_MODAL_OPEN: 'comment-modal-open',
  BATCH_ITEM_SELECTED: 'batch-item-selected'
} as const);
export const BATCH_SETTINGS = ({
  FOCUS_ANNOTATION: 'focus-annotation'
} as const);